import React from 'react'
import { Button, Icon } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'

const TourBottomComponent = (props) => {
  const {
    onClickPrevious,
    onClickNext,
    onClickSkip,
    numberOfDot,
    activeIndex,
    onClickFinish,
  } = props
  return (
    <div className="flex justify-between items-center pt-5 border-t border-gray-200">
      {onClickSkip ? (
        <Button
          className="w-96 text-left text-gray-500 capitalize"
          onClick={onClickSkip}
        >
          <FormattedMessage id="ai.feature.tour.skip" />
        </Button>
      ) : (
        <div className="w-96"></div>
      )}
      <div className="flex items-center space-x-2">
        {Array.from(Array(numberOfDot)).map((_, index) => (
          <span
            key={index}
            className={`w-3 h-3 rounded-full ${index === activeIndex ? 'bg-gray-500' : 'bg-gray-300'}`}
          ></span>
        ))}
      </div>
      <div className="flex flex-row">
        {onClickPrevious && (
          <Button
            className="text-gray-500 capitalize"
            onClick={onClickPrevious}
          >
            <Icon>chevron_left</Icon>
            <FormattedMessage id="ai.feature.tour.previous" />
          </Button>
        )}
        {onClickNext && (
          <Button className="text-gray-500 capitalize" onClick={onClickNext}>
            <FormattedMessage id="ai.feature.tour.next" />
            <Icon>chevron_right</Icon>
          </Button>
        )}
        {onClickFinish && (
          <Button className="text-gray-500 capitalize" onClick={onClickFinish}>
            <FormattedMessage id="ai.feature.tour.finish" />
          </Button>
        )}
      </div>
    </div>
  )
}

export default React.memo(TourBottomComponent)
